import axios from "axios";
import config from "../config";
import { getToken } from "../utils/tokenUtils";

const apiurl = config.API_URL;


export const joinWaitlist = async () => {
    const token = getToken();
    try {
        const response = await axios.post(`${apiurl}/api/v1/user/join-waitlist`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        return Promise.reject(error.response.data);
    }
};